import { parseDate } from '@/utils/utils';

export class Task {
    constructor(rawObject) {
        this.id = rawObject.id;
        this.creationTime = rawObject.creationTime;
        this.creator = rawObject.creator;
        this.status = rawObject.status;
        this.type = rawObject.type;
        this.completionTime = rawObject.completionTime;
        this.ccmSfdNumber = rawObject.ccmSfdNumber;
        this.errorMessage = rawObject.errorMessage;
        this.currentState = rawObject.currentState;

        this._result = rawObject.result;
    }

    get id() { return this._id; }
    set id(value) {
        if (typeof(value) === 'number')
            this._id = value;
    }

    get creationTime() { return this._creationTime; }
    set creationTime(value) {
        this._creationTime = parseDate(value);
    }

    get creator() { return this._creator; }
    set creator(value) {
        if (typeof(value) === 'string')
            this._creator = value;
    }

    get status() { return this._status; }
    set status(value) {
        if (typeof(value) === 'string')
            this._status = value;
    }

    get type() { return this._type; }
    set type(value) {
        if (typeof(value) === 'string')
            this._type = value;
    }

    //todo: parameters

    get completionTime() { return this._completionTime; }
    set completionTime(value) {
        this._completionTime = parseDate(value);
    }

    //todo: result

    get controlCashMachine() { return this._controlCashMachine; }
    set controlCashMachine(value) {
        if (value instanceof Object)
            this._controlCashMachine = value;
    }

    get errorMessage() { return this._errorMessage; }
    set errorMessage(value) {
        if (typeof(value) === "string")
            this._errorMessage = value;
    }

    get currentState() { return this._currentState; }
    set currentState(value) {
        if (typeof(value) === "string")
            this._currentState = value;
    }

    get ccmSfdNumber() { return this._ccmSfdNumber; }
    set ccmSfdNumber(value) {
        if (typeof(value) === "string")
            this._ccmSfdNumber = value;
    }

    get result() { return this._result; }
}